import { Search } from 'history';
import queryStringUtil from 'query-string';

import { Term, Params, SearchableType, SearchableParam } from '../types';

export function mapTermsToPublicIds(terms: Term[]) {
  return terms.map(term => term.publicId) as string[];
}

function mapPublicIdsToTerms(publicIds: string[]): Pick<Term, 'publicId'>[] {
  return publicIds.map(publicId => ({ publicId }));
}

type APIQueryObject = Partial<Record<SearchableParam, string | string[] | string[][]>>;
const defaultQuery: APIQueryObject = {
  sort: [
    ['hasBreachStatus', 'desc'],
    ['hasQualityIssues', 'desc'],
    ['name', 'asc'],
  ],
};

/* FIXME: searchV2: Type the returnType */
export function mapURLQueryToParams(search: Search) {
  const queryObject = queryStringUtil.parse(search, { arrayFormat: 'comma' });

  return Object.keys(queryObject).reduce((acc, key) => {
    const scope = key as SearchableType;
    const terms = mapPublicIdsToTerms(queryObject[key] as string[]);
    acc[key] = { scope, terms };
    return acc;
  }, {} as any);
}

export function mapParamsToAPIQueryObject(params: Params, withSort?: boolean): APIQueryObject {
  const queryObject = Object.keys(params).reduce(
    (acc, curr: SearchableType) => {
      const key = `${curr}PublicIds` as SearchableParam;
      acc[key] = [mapTermsToPublicIds(params[curr])];
      return acc;
    },
    /* NOTE:
    Below: Spreading defaultQuery is necessary since the reference value will be retained each time it is run,
    as this will copy the object each time.
    This was fixed in https://bitbucket.org/atlassian/slo-ui/pull-requests/336
    */
    withSort ? { ...defaultQuery } : {}
  );

  return queryObject;
}

export function mapParamsToAPIQuery(params: Params, withSort?: boolean): Search {
  if (!params) return '';

  const queryObject = mapParamsToAPIQueryObject(params, withSort);

  // Using arrayFormat: 'none' will encode array properties as multiple query args with the same key
  const queryString = queryStringUtil.stringify(queryObject, { arrayFormat: 'none' });

  return queryString;
}

export { default as queryString } from 'query-string';
